module.exports = __webpack_public_path__ + "img/u213.dc45d94a.png";